import { ref, readonly } from 'vue'

export const usePrefectures = (initial, master) => {
  const state = ref(structuredClone(initial))

  const set = (areas) => {
    /* NOTE: デフォルトはUnicodeコードポイントの昇順のため、
     * ソート順について処理を記述する必要がある。
     * 数字の比較の場合は単純に減算をしてあげれば、速いらしい */
    state.value = Object.values(areas).flat().sort((a, b) => a - b)
  }

  const reset = () => {
    state.value = structuredClone(initial)
  }

  const clear = () => {
    state.value = []
  }

  // 選択された地域テキスト(カンマ区切り)
  const getText = () => {
    let names = []
    state.value.some(id => {
      let index = master.findIndex(prefecture => id == prefecture.id)
      if(index !== -1) {
        names.push(master[index].name)
      }
    })
    return names.join(',')
  }

  return { prefectures: readonly(state), set, reset, clear, getText }
}